import { MatchCardContent } from "@components/MatchCard/MatchCardContent";
import { ShopMatchReception } from "@components/ShopMatchReception";
import styles from "./index.module.css";
import type { ShopMatchCard_ShopMatchFragment } from "./__generated__/fragments";

type Props = {
  shopUuid: string;
  shopName: string;
  shopTel: string;
  shopTelWithHyphen: string;
  shopMatch: ShopMatchCard_ShopMatchFragment;
};

export const ShopMatchCard: React.FC<Props> = ({
  shopUuid,
  shopName,
  shopTel,
  shopTelWithHyphen,
  shopMatch,
}) => {
  return (
    <div className={styles.cardBox}>
      <div className={styles.content}>
        <MatchCardContent match={shopMatch.match} showsTournamentName={true} />
      </div>

      <div className={styles.reservation}>
        <ShopMatchReception
          shopMatch={shopMatch}
          shopUuid={shopUuid}
          shopName={shopName}
          shopTel={shopTel}
          shopTelWithHyphen={shopTelWithHyphen}
        />
      </div>
    </div>
  );
};
